import { useEffect, useState } from 'react';
import { Alert, Box, Grid, Typography } from '@mui/material';
import { Tag } from '../models/tag';
import Meal, { mapMealFromApi } from '../models/meal';
import { getTagsByGroup } from '../api/tag-api';
import { callApiWithData } from '../api/call-api';
import ChoiceCard from '../components/ChoiceCard/ChoiceCard';
import MealItem from '../components/Meal/MealItem';
import Loader from '../components/UI/General/Loader';

const CookingGuidanceByType = () => {
  const [mealTypes, setMealTypes] = useState<Tag[]>([]);
  const [selectedType, setSelectedType] = useState<Tag | null>(null);
  const [meals, setMeals] = useState<Meal[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getTagsByGroup().then((groups) => setMealTypes(groups.meal_type));
  }, []);

  const handleSelect = async (type: Tag) => {
    setSelectedType(type);
    setLoading(true);
    setError(null);
    try {
      const response = await callApiWithData('/chef-meals', { tags: { meal_type: [type.id] } }, 'POST');
      setMeals(response.meals.map(mapMealFromApi));
    } catch {
      setError('Nepodařilo se načíst recepty.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Podle typu jídla
      </Typography>

      <Grid container spacing={2} sx={{ mb: 3 }}>
        {mealTypes.map((type) => (
          <Grid item xs={4} md={3} key={type.id}>
            <ChoiceCard icon={null} title={type.name} variant="small" onClick={() => handleSelect(type)} />
          </Grid>
        ))}
      </Grid>

      {selectedType && (
        <Typography variant="subtitle1" sx={{ mb: 2 }}>
          {selectedType.name}
        </Typography>
      )}

      {loading && <Loader />}

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {!loading && !error && selectedType && meals.length === 0 && (
        <Typography variant="body1" color="text.secondary">
          Žádné recepty pro tento typ.
        </Typography>
      )}

      {!loading && !error && meals.length > 0 && (
        <Grid container spacing={{ xs: 2, md: 4 }}>
          {meals.map((meal) => (
            <Grid key={meal.id} item xs={12} md={6}>
              <MealItem meal={meal} />
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default CookingGuidanceByType;
